import { gql } from "apollo-boost";

export const MESSAGE_TEMPLATES_MUTATE = gql`
mutation messageTemplatesMutate($seqNo: Int, $name: String!, $subject: String!, $body: String!, $description: String!, $type: String!, $industry: String!, $createDate: String!, $updateSource: String!, $state: String!, $clubId: Int, $leagueId: Int) {
  messageTemplatesMutate(programData: {seqNo: $seqNo, name: $name, subject: $subject, body: $body, description: $description, type: $type,industry: $industry, createDate: $createDate, updateSource: $updateSource, state: $state, clubId: $clubId, leagueId: $leagueId}) {
    edges {
      node {
				seqNo
        name
        subject
        body
        description
        type
        industry
        createDate
        updateDate
        state
        clubId
        leagueId
      }
      __typename
    }
    __typename
  }
}`;

export const MESSAGE_TEMPLATES_DELETE = gql`
  mutation messageTemplatesDelete($seqNo: Int!) {
    messageTemplatesDelete(seqNo: $seqNo) {
      success
      message
    }
  }`;

export const TRIGGER_JOB = gql`
  mutation TriggerJob($jobName: String!, $jobParams: JobParamsInput!) {
    triggerJob(jobName: $jobName, jobParams: $jobParams) {
      success
      message
      result
    }
    }`;